import apiBooking from '@/api/booking';
import { actions, mutations } from './trip.d';
import firebaseFunctions from '@/api/firebaseFunctions';

export default {
  /**
   * Get restaurant booking of the current user
   */
  [actions.getRestaurantBooking]: async function({ rootState, commit }) {
    const { userId } = rootState.User.currentUser;
    const bookings = await apiBooking.getRestaurantBooking(userId);
    return commit(mutations.setTrips, bookings);
  },

  /**
   * Create restaurant booking for current user
   */
  // eslint-disable-next-line max-lines-per-function
  [actions.createRestaurantBooking]: async function(
    { dispatch, rootState },
    payload
  ) {
    const {
      agentId: conciergeId,
      screenName: conciergeName
    } = rootState.Concierge.currentConcierge;
    const { userId, language } = rootState.User.currentUser;
    const { channelUrl } = rootState.Channel.currentChannel;

    const booking = {
      userId,
      language,
      createdBy: conciergeId,
      childAges: Array.from(Array(payload.childCount)).map(() => 5),
      ...payload
    };

    const message = {
      name: payload.restaurantName,
      language,
      channelUrl,
      receiverId: userId,
      senderId: conciergeId,
      senderName: conciergeName
    };

    dispatch('loading/start', 'trip.addEditRestaurantBooking', { root: true });
    try {
      await apiBooking.createRestaurantBooking(booking);
      await firebaseFunctions.addItineraryMessage(message);
    } catch (error) {
      // TODO: handle error correctly?
    }
    dispatch('loading/end', 'trip.addEditRestaurantBooking', { root: true });
  },

  /**
   * Update restaurant booking for current user
   */
  [actions.updateRestaurantBooking]: async function(
    { dispatch, rootState },
    payload
  ) {
    const { userId } = rootState.User.currentUser;
    const booking = {
      userId,
      childAges: Array.from(Array(payload.childCount)).map(() => 5),
      ...payload
    };
    dispatch('loading/start', 'trip.addEditRestaurantBooking', { root: true });

    try {
      await apiBooking.updateRestaurantBooking(booking);
    } catch (error) {
      // TODO: handle error correctly
    }
    dispatch('loading/end', 'trip.addEditRestaurantBooking', { root: true });
  },

  /**
   * Cancel restaurant booking for current user
   */
  [actions.cancelRestaurantBooking]: async function(
    { dispatch, rootState },
    bookingId
  ) {
    const { userId } = rootState.User.currentUser;
    const payload = {
      userId,
      bookingId
    };
    dispatch(
      'loading/start',
      `trip.trip.cancelRestaurantBooking.${bookingId}`,
      {
        root: true
      }
    );

    try {
      await apiBooking.cancelRestaurantBooking(payload);
    } catch (error) {
      // TODO: handle error correctly
    }

    dispatch('loading/end', `trip.trip.cancelRestaurantBooking.${bookingId}`, {
      root: true
    });
  }
};
